// extracted by mini-css-extract-plugin
module.exports = {"capsuleContainer":"capsule-ctrl_capsuleContainer__MzBxg","hidden":"capsule-ctrl_hidden__3Dmn6","smallLoader":"capsule-ctrl_smallLoader__2tgW7","logo":"capsule-ctrl_logo__1_-aZ"};